import classnames from 'classnames';
import React, { useState } from 'react';

import {
  trackPaidTransferDeviceUnrecognised,
  trackPaidTransferNewLinkRequested,
} from '../tracking';
import Icon from '@wetransfer/transfer/component/icon';
import { useEffectOnce } from '@wetransfer/transfer/hooks/useEffectOnce';
import Browser from '@wetransfer/transfer/modules/concorde-browser/browser';

import styles from './DeviceVerify.module.scss';
import { DeviceVerifyProps } from './types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
//this can be removed once the translation keys are placed in the translation file
const device_auth_translation_keys: any = {
  pre_auth_check: {
    title: "Oops, we don't recognise this device!",
    description:
      'We need to verify your device before you can download your files. Please request a new download link.',
  },
  post_auth_check: {
    title: 'Link sent',
    description:
      "We've sent a new download link to the email address you used to purchase the files. If you can't find it, please check your Spam folder.",
  },
  cta: {
    new_link: 'Get new link',
  },
};

const DeviceVerify = ({ onClick }: DeviceVerifyProps): JSX.Element => {
  const [linkSent, setLinkSent] = useState(false);

  const isDesktop = !Browser.isMobile;

  const stageOfVerification = linkSent ? 'post_auth_check' : 'pre_auth_check';

  const title = device_auth_translation_keys[stageOfVerification].title;

  const description =
    device_auth_translation_keys[stageOfVerification].description;

  const onClickHandler = () => {
    setLinkSent(true);
    onClick?.();

    trackPaidTransferNewLinkRequested();
  };

  useEffectOnce(() => {
    trackPaidTransferDeviceUnrecognised();
  });

  return (
    <div className={styles.container}>
      <div
        className={classnames(styles.content, {
          [styles.content__desktop]: isDesktop,
        })}
      >
        <Icon type={isDesktop ? 'FullLock' : 'GreyedOutLock'} />

        <p
          className={classnames(styles.title, {
            [styles.title__desktop]: isDesktop,
          })}
        >
          {title}
        </p>

        <p
          className={classnames(styles.description, {
            [styles.description__desktop]: isDesktop,
          })}
        >
          {description}
        </p>
      </div>

      {!linkSent && (
        <>
          {isDesktop && <hr className={styles.divider} />}
          <button
            data-testid="deviceVerifyCta"
            className={classnames(styles.cta, {
              [styles.cta__desktop]: isDesktop,
            })}
            onClick={onClickHandler}
          >
            {device_auth_translation_keys.cta.new_link}
          </button>
        </>
      )}
    </div>
  );
};

export { DeviceVerify };
